/// <reference path="../wpt.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.WorkViewClassList";
        class WorkViewClassListWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("WorkViewClassListWidgetTypeClass.createInstance()");
                    return new WorkViewClassListWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("WorkViewClassListWidgetTypeClass._storeHtml()");
                    WorkViewClassListWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WorkViewClassListWidgetTypeClass::constructor");
                if (WorkViewClassListWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/WorkViewClassList/workview-classlist.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.WorkViewClassListWidgetTypeClass = WorkViewClassListWidgetTypeClass;
        class WorkViewClassListWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._loader = null;
                this._listHolder = null;
                this._dataList = null;
                this._viewConfigFile = null;
                this._presentAsButtons = null;
                this._buttonsVertical = null;
                this._buttonPalette = null;
                this._entryList = null;
                this.presentInstance = () => {
                    this._log.info("WorkViewClassListWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = WorkViewClassListWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._listHolder = this._container.querySelector('#workViewClassListHolder');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#workViewClassListWidgetTitle'), 'STR_WPT_CLASSES');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#workViewClassListLoading'), 'STR_WPT_LOADING');
                    if (this._presentAsButtons && this._buttonsVertical) {
                        this._listHolder.classList.remove('widget__body-item--no-padding');
                    }
                    if (this._presentAsButtons) {
                        let usePrimary = false;
                        if (this._config.hasOwnProperty('SuppressHeading') && this._config.SuppressHeading === true) {
                            usePrimary = true;
                        }
                        let bpConfig = {
                            Orientation: this._buttonsVertical ? 'Vertical' : 'Horizontal',
                            SuppressNoItemsBanner: true,
                            UsePrimaryColour: usePrimary
                        };
                        this._buttonPalette = new Widgets.ComponentButtonPalette(this._core, this._listHolder, this, bpConfig, this._classClicked);
                        this._buttonPalette.present();
                    }
                    else {
                        let listConfig = {
                            SelectItemCallback: this._classClicked
                        };
                        this._dataList = new Widgets.ComponentDataList(this._core, this._listHolder, this, listConfig);
                        this._dataList.present();
                    }
                    this._core.Functions.showElement(this._loader);
                    let conf = this._config;
                    this._entryList = null;
                    if (conf.hasOwnProperty('Applications') && conf.Applications.length > 0) {
                        let applicationList = null;
                        if (conf.Applications[0].hasOwnProperty('ApplicationName')) {
                            this._entryList = conf.Applications;
                            applicationList = this._entryList.map(entry => entry.ApplicationName);
                        }
                        else {
                            applicationList = conf.Applications;
                        }
                        let requestApplications = {
                            Applications: applicationList
                        };
                        let request = JSON.stringify(requestApplications);
                        this._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/GetAllClassesForApplications', request, this._presentClassList, null, this._callErrorHandler, this._callFailedHandler);
                    }
                    else {
                        this._core.Loader.genericServiceCall('/WorkView.svc/rest/GetAllClasses', this._presentClassList, this._callErrorHandler, this._callFailedHandler);
                    }
                    this._type.instanceReady(this.getHandle());
                };
                this._presentClassList = (classData) => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("WorkViewClassListWidgetInstanceClass._presentClassList()");
                    this._core.Functions.hideElement(this._loader);
                    if (this._presentAsButtons) {
                        this._buttonPalette.clearDisplay();
                    }
                    else {
                        this._dataList.clearList();
                    }
                    let applications = classData.Applications;
                    let applicationsLength = applications.length;
                    let entries = [];
                    for (let a = 0; a < applicationsLength; a++) {
                        let application = applications[a];
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`processing application '${application.Name}'`);
                        }
                        let appConfig = yield this._core.Helper.getWvViewConfigForApplication(this._viewConfigFile, application.Name);
                        let label = null;
                        let appConfigEntry = null;
                        if (this._entryList && this._entryList.length > 0) {
                            appConfigEntry = this._entryList.find(entry => entry.ApplicationName == application.Name);
                            if (appConfigEntry && appConfigEntry.hasOwnProperty('DisplayName') && appConfigEntry.DisplayName.length > 0) {
                                label = this._core.Locale.getTranslation(appConfigEntry.DisplayName);
                            }
                            if (appConfigEntry == null || appConfigEntry == undefined) {
                                console.warn(`Applications configured as entries, but application '${application.Name}' not found. Shouldn't happen.`);
                                continue;
                            }
                        }
                        if (label == null) {
                            if (appConfig && appConfig.hasOwnProperty('DisplayName') && appConfig.DisplayName.length > 0) {
                                label = this._core.Locale.getTranslation(appConfig.DisplayName);
                            }
                        }
                        if (label == null) {
                            label = application.Name;
                        }
                        let appEntry = {
                            ApplicationName: application.Name,
                            Id: application.Id.toString(10),
                            DisplayName: label,
                            Classes: []
                        };
                        let classesAdded = false;
                        let classesLength = application.Classes.length;
                        for (let c = 0; c < classesLength; c++) {
                            let clazz = application.Classes[c];
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`processing class '${clazz.Name}'`);
                            }
                            if (!clazz.Readonly) {
                                let classConfig = null;
                                if (appConfig && appConfig.Classes.length > 0) {
                                    classConfig = appConfig.Classes.find(cl => cl.Name == clazz.Name);
                                }
                                if ((classConfig == null || classConfig == undefined) || !classConfig.Readonly) {
                                    let label = null;
                                    let icon = null;
                                    let classConfigEntry = null;
                                    if (appConfigEntry && appConfigEntry.Classes.length > 0) {
                                        classConfigEntry = appConfigEntry.Classes.find(entry => entry.ClassName == clazz.Name);
                                        if (classConfigEntry && classConfigEntry.hasOwnProperty('DisplayName') && classConfigEntry.DisplayName.length > 0) {
                                            label = this._core.Locale.getTranslation(classConfigEntry.DisplayName);
                                        }
                                        if (classConfigEntry && classConfigEntry.hasOwnProperty('Icon') && classConfigEntry.Icon) {
                                            icon = classConfigEntry.Icon;
                                        }
                                    }
                                    if (appConfigEntry && (classConfigEntry == null || classConfigEntry == undefined)) {
                                        if (this._log.isTraceEnabled()) {
                                            this._log.trace(`class '${clazz.Name}' not in entry list, ignore...`);
                                        }
                                        continue;
                                    }
                                    if (label == null) {
                                        if (classConfig && classConfig.hasOwnProperty('DisplayName') && classConfig.DisplayName.length > 0) {
                                            label = this._core.Locale.getTranslation(classConfig.DisplayName);
                                        }
                                    }
                                    if (label == null) {
                                        label = clazz.Name;
                                    }
                                    let classEntry = {
                                        ClassName: clazz.Name,
                                        Id: application.Name + ":" + clazz.Name,
                                        DisplayName: label,
                                        Icon: icon
                                    };
                                    appEntry.Classes.push(classEntry);
                                    if (!classesAdded) {
                                        classesAdded = true;
                                    }
                                }
                            }
                        }
                        if (classesAdded) {
                            entries.push(appEntry);
                        }
                    }
                    this._presentClassListData(entries);
                });
                this._presentClassListData = (entries) => {
                    this._log.info("WorkViewClassListWidgetInstanceClass._presentClassListData()");
                    if (this._presentAsButtons) {
                        let buttonOptions = [];
                        entries.forEach(appEntry => {
                            appEntry.Classes.forEach(classEntry => {
                                let buttonOption = {
                                    Identifier: classEntry.Id,
                                    Label: classEntry.DisplayName,
                                    Icon: classEntry.Icon
                                };
                                buttonOptions.push(buttonOption);
                            });
                        });
                        this._buttonPalette.displayOptions(buttonOptions);
                    }
                    else {
                        let listData = {
                            Items: []
                        };
                        entries.forEach(appEntry => {
                            let appItem = {
                                Id: appEntry.Id,
                                DisplayName: appEntry.DisplayName,
                                Items: []
                            };
                            listData.Items.push(appItem);
                            appEntry.Classes.forEach(classEntry => {
                                let classItem = {
                                    Id: classEntry.Id,
                                    DisplayName: classEntry.DisplayName
                                };
                                appItem.Items.push(classItem);
                            });
                        });
                        this._dataList.displayData(listData);
                    }
                };
                this._classClicked = (id) => {
                    this._log.info("WorkViewClassListWidgetInstanceClass._classClicked()");
                    let splitPos = id.indexOf(":");
                    let appName = id.substring(0, splitPos);
                    let className = id.substring(splitPos + 1);
                    if (this._presentAsButtons) {
                        this._buttonPalette.clearOptionSelection();
                        this._buttonPalette.selectOption(id);
                    }
                    else {
                        this._dataList.clearItemSelection();
                        this._dataList.selectItem(id);
                    }
                    let requestCreateObject = {
                        Application: appName,
                        Class: className
                    };
                    let conf = this._config;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`clicked class '${className}' of application '${appName}'`);
                    }
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.WV_CLASS_SELECTED);
                    navEvent.ActivationID = 0;
                    navEvent.PrimaryContext = requestCreateObject;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = this._currentLayout;
                    if (conf.hasOwnProperty("LaunchLayout") && conf.LaunchLayout) {
                        if (conf.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = conf.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (conf.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(conf.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._callFailedHandler = (json) => {
                    this._log.info("WorkViewClassListWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("WorkViewClassListWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WorkViewClassListWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                let conf = this._config;
                if (conf.hasOwnProperty('ViewConfiguration') && conf.ViewConfiguration) {
                    this._viewConfigFile = conf.ViewConfiguration;
                }
                else {
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('WorkViewViewConfiguration') && appConfig.WorkViewViewConfiguration) {
                        this._viewConfigFile = appConfig.WorkViewViewConfiguration;
                    }
                }
                this._buttonsVertical = true;
                if (conf.hasOwnProperty('Type') && conf.Type === 'Buttons') {
                    this._presentAsButtons = true;
                    if (conf.hasOwnProperty('ButtonsVertical') && !conf.ButtonsVertical) {
                        this._buttonsVertical = false;
                    }
                }
                else {
                    this._presentAsButtons = false;
                }
            }
        }
        WorkViewClassListWidgetInstanceClass.HtmlData = null;
        Widgets.WorkViewClassListWidgetInstanceClass = WorkViewClassListWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
